module.exports = __webpack_public_path__ + "img/back.3d164bf1.png";